import styled, { css } from 'styled-components';
import { Link, Text } from '@99designs/emu';
import { colors } from '@99designs/emu/settings';
import { getPaginationArray } from './paginationArray';
import type { PaginationArray } from './paginationArray';

interface RenderPageCounterProps {
    currentPage: number;
    totalPageCount: number;
    onClick?: React.MouseEventHandler;
}

export function mobileRenderPageCounter({ currentPage, totalPageCount }: RenderPageCounterProps) {
    return (
        <Text weight="bold" size="size4">
            {currentPage} of {totalPageCount}
        </Text>
    );
}

// This is a fork of libs/emu/src/components/Pagination/defaultRenderPageCounter.tsx
export function defaultRenderPageCounter(
    onPageChange: (targetPage: number) => void
): (props: RenderPageCounterProps) => React.ReactNode {
    return function ({ currentPage, totalPageCount }: RenderPageCounterProps) {
        const items: PaginationArray = getPaginationArray({ currentPage, totalPageCount });

        return items.map((pageNumber, index) => {
            if (pageNumber === '...') {
                return <span key={`truncation-${index}`}>&hellip;</span>;
            }

            const isItemCurrentPage = currentPage === pageNumber;

            return (
                <PaginationLink
                    key={pageNumber}
                    underline="none"
                    aria-current={isItemCurrentPage ? 'page' : undefined}
                    onClick={() => onPageChange(pageNumber)}
                >
                    <PageText isCurrent={isItemCurrentPage} weight="bold" size="size4">
                        {pageNumber}
                    </PageText>
                </PaginationLink>
            );
        });
    };
}

const PageText = styled(Text)<{ isCurrent?: boolean }>`
    display: inline-block;
    text-align: center;
    min-width: 14px;
    border-bottom-width: 2px;
    border-bottom-style: solid;
    border-bottom-color: transparent;

    &:hover,
    &:focus {
        border-bottom-color: ${colors.grey700};
    }

    ${({ isCurrent }) =>
        isCurrent &&
        css`
            border-bottom-color: ${colors.grey800};
        `}
`;

const PaginationLink = styled(Link)`
    display: block;
    &:before {
        content: '';
        display: block;
        position: absolute;
        width: 44px;
        height: 44px;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    &:focus-visible::after {
        bottom: 0;
    }
    &:hover,
    &:focus {
        ${PageText} {
            border-bottom-color: ${colors.grey700};
        }
    }
`;
